import * as React from "react";

const SvgGraphics = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 21 20"
    fill="none"
  >
    <g clipPath="url(#clip0_13050_1712)">
      <rect
        x="4.25"
        y="3.75"
        width="12.5"
        height="12.5"
        rx="1.25"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <rect
        x="0.5"
        y="4"
        width="1.5"
        height="12"
        rx="0.75"
        fill="currentColor"
      />
      <rect
        x="19"
        y="4"
        width="1.5"
        height="12"
        rx="0.75"
        fill="currentColor"
      />
      <path
        d="M8.05124 9.27094C8.24284 8.93334 8.72932 8.93334 8.92093 9.27094L12.0622 14.8058C12.2514 15.1391 12.0107 15.5526 11.6274 15.5526H5.34477C4.96151 15.5526 4.72075 15.1391 4.90993 14.8058L8.05124 9.27094Z"
        fill="currentColor"
      />
      <path
        d="M13.079 11.9753C13.2757 11.6683 13.7243 11.6683 13.921 11.9753L16.0067 15.2302C16.22 15.563 15.981 16 15.5858 16H11.4142C11.019 16 10.78 15.563 10.9933 15.2302L13.079 11.9753Z"
        fill="currentColor"
      />
      <rect
        x="11.6013"
        y="5.88098"
        width="3"
        height="3"
        rx="1.5"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_13050_1712">
        <rect
          width="1em"
          height="1em"
          fill="currentColor"
          transform="translate(0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default SvgGraphics;
